import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { setSubscriptionData } from '../../utils/storage';
import { fetchWebPushSubscribe } from '../../repositories/notification-center/v1/web-push-subscribe';
export function registerEndpoint(_x, _x2, _x3) {
  return _registerEndpoint.apply(this, arguments);
}

function _registerEndpoint() {
  _registerEndpoint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(httpApi, subscription, fromPopup) {
    var response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchWebPushSubscribe({
              httpApi: httpApi,
              parameters: {
                subscription: subscription,
                fromPopup: fromPopup
              }
            });

          case 2:
            response = _context.sent;

            if (!(response.statusCode === 200)) {
              _context.next = 7;
              break;
            }

            setSubscriptionData(response.response.userId);
            _context.next = 8;
            break;

          case 7:
            throw new Error(response.response.message);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _registerEndpoint.apply(this, arguments);
}